<template>
  <el-dialog
    :visible.sync="showDialog"
    :width="modalWidth"
    top="15vh"
    :modal-append-to-body="false"
    :before-close="handleClose"
    custom-class="custom-scrollable hide-cancel-button"
  >
    <div class="flex flex-col items-center">
      <h3 class="font-semibold text-xl text-root-2">FX Transfer Restricted</h3>
      <p
        style="word-break: normal"
        class="font-light text-sm mt-2 mb-5 text-center"
      >
        The KYC for your account has not yet been completed. <br />contact your
        relationship officer or manager for support
      </p>
      <warning-icon-2 size="h-24 w-24" />
      <div class="flex items-center gap-x-3">
        <o-button
          class="bg-primary text-xs rounded mt-5 shadow-sm w-full"
          @click="contactAdmin"
          >Contact Admin</o-button
        >
        <o-button
          v-if="!tenantIsTorus"
          class="bg-primary text-xs rounded mt-5 shadow-sm w-full"
          @click="goBack"
          >Go to Dashboard</o-button
        >
        <o-button
          v-else
          class="bg-primary text-xs rounded mt-5 shadow-sm w-full"
          @click="logout"
          >Logout</o-button
        >
      </div>
    </div>
  </el-dialog>
</template>
<script>
import breakpoints from '@/utils/breakpoints.js'
import logout from '@/mixins/logout.js'
import tenant from '@/mixins/tenant.js'
export default {
  name: 'DepositWallet',
  mixins: [logout, tenant],
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    view: {
      type: String,
      default: 'wallet-address'
    }
  },
  components: {
    WarningIcon2: () => import('@/assets/icons/WarningIcon2.vue')
  },
  data () {
    return {
      currentView: this.view
    }
  },
  computed: {
    modalWidth () {
      return breakpoints.lgAndUp ? '27%' : breakpoints.mdAndUp ? '70%' : '90%'
    }
  },
  methods: {
    contactAdmin () {
      window.open(
        this.tenantIsTorus
          ? 'mailto:hello@torusmara.com'
          : 'https://ovalfi.atlassian.net/servicedesk/customer/portal/'
      )
    },
    goBack () {
      this.$router.push('/dashboard')
    },
    handleClose () {}
  }
}
</script>

<style scoped>
.qr-code {
  box-shadow: 0px 2px 3px rgba(2, 1, 1, 0.09);
  border-radius: 11px;
}
.address {
  background: #f5f6fb;
  opacity: 0.66;
  border-radius: 0px 0px 9px 9px;
}
button {
  border-radius: 200px;
}
>>> .el-select {
  width: 100%;
}

>>> .el-input__prefix {
  left: 1px;
}
>>> .el-input__inner {
  font-size: 0.8rem;
  font-weight: 400;
}
>>> .hide-cancel-button .el-dialog__headerbtn {
  display: none !important;
}
</style>
